// @flow

import { TYPE_OPTIONS } from '../../../../models'

export function TypeRenderer ({ value }: { value: string }) {
  if (!value) return null

  return TYPE_OPTIONS.find(opt => opt.value === value)?.label
}
